import React, { Component } from 'react'

import PropTypes from 'prop-types'

import Modal from 'react-bootstrap-modal'

import POIForm from './index'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'

class AddPOIFormModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    event: PropTypes.object,
    dates: PropTypes.array,
    currentDay: PropTypes.number,
    user: PropTypes.object
  }

  static defaultProps = {
    isOpen: false
  }

  render() {
    const { isOpen, onClose, dates, event, user } = this.props
    return (
      <Modal show={isOpen} onHide={() => onClose()} dialogClassName="event-modal" aria-labelledby="ModalHeader">
        <Modal.Body>
          <POIForm isFluid={true} dates={dates} event={event} onSave={() => onClose()} t={this.props.t} user={this.props.user} />
          <i className="event-modal__close icon-close" onClick={() => onClose()} />
        </Modal.Body>
      </Modal>
    )
  }
}

const enhance = compose(translate('create_poi'))
export default enhance(AddPOIFormModal)



// WEBPACK FOOTER //
// src/components/POIForm/AddPOIFormModal.js